module.exports = __webpack_public_path__ + "img/clogo.33203d0b.png";